<div class="form-row m-0">
    <div class="form-row position-relative w-100">
        <mat-form-field appearance="outline" class="w-100">
            <input type="text" placeholder="Select Pfs" matInput [ngModel]="inputLabel" [formControl]="pfsControl"
                [matAutocomplete]="pfss" />
            <mat-autocomplete #pfss="matAutocomplete" (optionSelected)="emitPfs($event.option.value)">
                <mat-option *ngFor="let option of pfsOptions | async" [value]="option">
                    {{ option.code }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</div>